// Small reusable KPI tile used across dashboards.
import { cn } from "@/lib/utils";

export const StatTile = ({ icon: Icon, label, value, hint, accent = "primary", className }) => {
  const accents = {
    primary: "text-primary bg-primary/10",
    accent: "text-accent bg-accent/10",
    success: "text-success bg-success/12",
    warning: "text-warning bg-warning/15",
  };
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-2xl border border-border/70 bg-card p-5 sm:p-6 hover:shadow-soft transition-shadow",
        className
      )}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-muted-foreground">
            {label}
          </div>
          <div className="mt-2 font-display text-2xl sm:text-3xl font-bold tracking-tight text-foreground truncate">
            {value}
          </div>
          {hint && <div className="mt-1 text-xs text-muted-foreground">{hint}</div>}
        </div>
        {Icon && (
          <span className={cn("inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl", accents[accent])}>
            <Icon className="h-5 w-5" />
          </span>
        )}
      </div>
    </div>
  );
};

export default StatTile;
